
export default function AboutSection() {
  const values = [
    { icon: 'ri-lightbulb-line', title: 'Creativity', description: 'Innovative solutions that stand out' },
    { icon: 'ri-focus-3-line', title: 'Precision', description: 'Attention to every detail matters' },
    { icon: 'ri-time-line', title: 'Time Management', description: 'Delivering projects on schedule' },
    { icon: 'ri-chat-3-line', title: 'Communication', description: 'Clear and effective collaboration' },
    { icon: 'ri-book-open-line', title: 'Continuous Learning', description: 'Always evolving with trends' }
  ];

  return (
    <section id="about" className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div>
              <h4 className="text-yellow-400 font-semibold text-lg mb-4">
                <a href="#about" className="hover:text-yellow-300 transition-colors">About Me</a>
              </h4>
              <h3 className="text-4xl lg:text-5xl font-bold text-white mb-6">
                Passionate About <span className="text-yellow-400">Design Excellence</span>
              </h3>
              <p className="text-gray-300 text-lg leading-relaxed mb-6">
                With over 5 years of experience in graphics design, I specialize in creating visual identities that resonate with audiences and drive business success. My passion lies in transforming complex ideas into simple, elegant, and impactful designs.
              </p>
              <p className="text-gray-300 text-lg leading-relaxed">
                I believe in user-centered thinking, where every design decision is made with the end user in mind. My expertise spans across <strong className="text-yellow-400">CorelDRAW, Figma, Adobe Illustrator, and Photoshop</strong>, allowing me to bring any creative vision to life.
              </p>
            </div>
            
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {values.map((value, index) => (
                <div key={index} className="bg-black/50 p-4 rounded-lg border border-gray-800 hover:border-yellow-400/50 transition-all duration-300">
                  <div className="w-8 h-8 flex items-center justify-center mb-3">
                    <i className={`${value.icon} text-yellow-400 text-xl`}></i>
                  </div>
                  <h5 className="text-white font-semibold text-sm mb-1">{value.title}</h5>
                  <p className="text-gray-400 text-xs">{value.description}</p>
                </div>
              ))}
            </div>
          </div>
          
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-yellow-400/20 to-yellow-600/20 rounded-2xl blur-2xl"></div>
            <div className="relative bg-black/30 backdrop-blur-sm p-8 rounded-2xl border border-gray-800">
              <img 
                src="https://static.readdy.ai/image/d841215d0ca23002ee5da92e181f5e13/0287742f1a7734e958f3c2f90416fbd4.jpeg"
                alt="Aniet Udoh - Creative Designer"
                className="w-full h-auto rounded-xl shadow-2xl object-cover mb-6"
              />
              
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <span className="text-gray-400">Experience</span>
                  <span className="text-yellow-400 font-semibold">5+ Years</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-400">Specialization</span>
                  <span className="text-white font-semibold">Brand Identity</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-400">Location</span>
                  <span className="text-white font-semibold">Available Worldwide</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-400">Response Time</span>
                  <span className="text-yellow-400 font-semibold">&lt; 24 Hours</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
